export var screenerKeys={WEEKLY_GAINERS:'Weekly_Gainers',WEEKLY_LOSERS:'Weekly_Losers',INDICES:'Indices'};